import { SystemConfigurationResp } from 'types/api/response/system-configuration-resp'

import { api } from './api'

export const getSystemConfiguration = () =>
  api.get<SystemConfigurationResp>('/system_configuration')
